import styled, { css } from 'styled-components';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';
import { Typography } from '../../../foundation/Typography/styled.js';

var denseFlexStyles = css(["flex-direction:row;gap:", ";align-items:center;justify-content:flex-start;"], themeGet('spacing.sm'));
var flexStyles = css(["flex-direction:column;align-items:flex-start;justify-content:flex-start;"]);
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1n3fq6n-0"
})(["display:flex;flex-direction:", ";", " max-width:inherit;text-decoration:none;overflow:hidden;", "{width:100%;}"], function (_ref) {
  var $dense = _ref.$dense;
  return $dense ? 'row' : 'column';
}, function (props) {
  return props.$dense ? denseFlexStyles : flexStyles;
}, Typography);

export { Container };
